// extracted by mini-css-extract-plugin
module.exports = {"dashboardButton":"styles_dashboardButton__DitfN","blue":"styles_blue__2wWNO","gray":"styles_gray__BzISW","purple":"styles_purple__kCjDD","fit":"styles_fit__nVIud"};